import "./home.scss";
import React, { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth } from "../../firebase";
import { useAuth } from "../../context/AuthContext";
import MachineBoard from "../../board/MachineBoard";
import LegacyBoard from "../../board/LegacyBoard";
import LadderMark from "../../board/LadderMark";

const Home = () => {
  const { mode } = useAuth();
  const navigate = useNavigate();
  // Same as the legacy sidebar's logout: sign out, forget the cached user,
  // back to the login page.
  const logout = useCallback(async () => {
    try {
      await signOut(auth);
    } finally {
      window.localStorage.removeItem("user");
      navigate("/login");
    }
  }, [navigate]);

  // Render a board only once the account has been resolved. `mode` is null
  // right after sign-in (claims are still being checked); treating that as
  // legacy briefly mounted the legacy board for new board accounts, whose
  // components then read a users/{uid} profile those accounts don't have.
  return (
    <div className="home sb-has-ladder-mark">
      {mode === "machine" ? (
        <MachineBoard />
      ) : mode === "legacy" ? (
        <LegacyBoard />
      ) : (
        <div className="sb-stage-bg" style={{ background: "#0b0b0d" }}>
          <div className="sb-board-waiting">Connecting…</div>
        </div>
      )}
      {/* The legacy board has its own logout in its sidebar. */}
      <LadderMark onLogout={mode === "legacy" ? undefined : logout} />
    </div>
  );
};

export default Home;
